import type { StaticImageData } from "next/image";
import Image from "next/image";
import { HumanLobbyPlayer } from "@rosette/ts/src/business/lobby/HumanLobbyPlayer.js";
import { Role } from "@rosette/ts/src/business/role/Role.js";
import { getRoleIcon } from "@/components/icon/getRoleIcon.js";
import { BotLobbyPlayer } from "@rosette/ts/src/business/lobby/BotLobbyPlayer.js";
import { getBotIcon } from "@/components/icon/getBotIcon.js";
import { cn } from "@rosette/ts/src/util/cn.js";
import type { PlayerNameProps } from "@/components/game/stats/PlayerName.js";
import { PlayerName } from "@/components/game/stats/PlayerName.js";


interface PlayerHeaderProps extends PlayerNameProps {
    small?: boolean;
}


export function PlayerHeader({ className, small, player, ...nameProps }: PlayerHeaderProps) {
    let icon: StaticImageData;
    let iconAlt: string;
    if (player instanceof HumanLobbyPlayer) {
        const role = Role.get(player.getUserOrNull());
        icon = getRoleIcon(role);
        iconAlt = role.getDesc();
    } else if (player instanceof BotLobbyPlayer) {
        const botType = player.getBotType();
        icon = getBotIcon(botType);
        iconAlt = botType.getDesc();
    } else {
        throw new Error(`Unknown lobby player type: ${player.constructor.name}`);
    }

    const playerType = player.getPlayerType();
    return (
        <div className={cn("flex flex-row items-center gap-3", className ?? null)}>
            {!small && (
                <div className="grow-0 w-[4em] h-[4em] object-contain">
                    <Image src={icon} alt={iconAlt} title={iconAlt} />
                </div>
            )}
            <div>
                <PlayerName player={player} small={small} {...nameProps} />
                {!small && playerType && (
                    <p className="m-0 text-xl text-subtle">
                        {`${playerType.getName()} Player`}
                    </p>
                )}
            </div>
        </div>
    );
}
